import * as CONTEXT from '../../../../../shared/constants/analytics/contexts';

export const ADS_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/ads/analytics/report`,
  TRENDS: `/v1/ads/analytics/trends`,
  TOTALS: `/v1/ads/analytics/totals`,
};

export const SEO_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/seo/analytics/report`,
  TRENDS: `/v1/seo/analytics/trends`,
  TOTALS: `/v1/seo/analytics/totals`,
};

export const TRUEVIEW_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/unified-skan/analytics/report`,
  // TRENDS: `/v1/unified-skan/analytics/trends`,
  TOTALS: `/v1/unified-skan/analytics/totals`,
};

export const SOURCES_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/sources/analytics/report`,
  TOTALS: `/v1/sources/analytics/totals`,
};

export const OTT_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/ott/analytics/report`,
  TRENDS: `/v1/ott/analytics/trends`,
  TOTALS: `/v1/ott/analytics/totals`,
  WIDGETS: `/v1/ott/analytics/widgets`,
};

export const JOURNEYS_ANALYTICS_ENDPOINT = {
  REPORT: `/v1/journeys/analytics/report`,
  TRENDS: `/v1/journeys/analytics/trends`,
  TOTALS: `/v1/journeys/analytics/totals`,
};

export const EMAILS_ANALYTICS_ENDPOINT = {
  REPORT: '/v1/emails/analytics/report',
  TRENDS: `/v1/emails/analytics/trends`,
  TOTALS: '/v1/emails/analytics/totals',
};

export const ANALYTICS_REPORT_ENDPOINT_BY_CONTEXT = {
  [CONTEXT.ADS_TABLE]: ADS_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.SEO_TABLE]: SEO_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.TRUEVIEW_TABLE]: TRUEVIEW_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.SOURCES_TABLE]: SOURCES_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.OTT_TABLE]: OTT_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.JOURNEYS_TABLE]: JOURNEYS_ANALYTICS_ENDPOINT.REPORT,
  [CONTEXT.EMAILS_TABLE]: EMAILS_ANALYTICS_ENDPOINT.REPORT,
};

export const ANALYTICS_TRENDS_ENDPOINT_BY_CONTEXT = {
  [CONTEXT.ADS_TRENDS]: ADS_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.SEO_TRENDS]: SEO_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.OTT_TRENDS]: OTT_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.JOURNEYS_TRENDS]: JOURNEYS_ANALYTICS_ENDPOINT.TRENDS,
  [CONTEXT.EMAILS_TRENDS]: EMAILS_ANALYTICS_ENDPOINT.TRENDS,
};

export const ANALYTICS_REPORT_TOTALS_ENDPOINT_BY_CONTEXT = {
  [CONTEXT.ADS_TABLE]: ADS_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.SEO_TABLE]: SEO_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.TRUEVIEW_TABLE]: TRUEVIEW_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.SOURCES_TABLE]: SOURCES_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.OTT_TABLE]: OTT_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.JOURNEYS_TABLE]: JOURNEYS_ANALYTICS_ENDPOINT.TOTALS,
  [CONTEXT.EMAILS_TABLE]: EMAILS_ANALYTICS_ENDPOINT.TOTALS,
};
